<template>
  <div 
    class="card text-reset notification-item d-block dropdown-item position-relative"
    style="margin: 15px 5px;box-shadow: 0 0 4px rgba(0,0,0,0.15); width: 98%; cursor: pointer;"
  >
    <span v-if="item.status === null" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">1</span>
    <div class="d-flex align-items-center">
      <img :src="imgUrl" class="me-3 rounded-circle avatar-xs flex-shrink-0" style="width: 40px; height: 45px;" />

      <div class="flex-grow-1">
        <div class="d-flex align-items-center mb-1 justify-content-between">
            <h6 class="m-0  fs-13 fw-semibold">{{ item.from_user_name }} -> {{ item.to_user_name }} </h6>
            <a @click="loadTask(item.task_id)" class="text-muted text-primary fs-12"
                style="text-decoration: underline; cursor: pointer">
                <i class="fa-solid fa-list-check me-1"></i> Topshiriq
            </a>
        </div>
        <p class="fs-13 text-muted mb-1">{{ item.message }}</p>

        <p class="mb-0 fs-11 fw-medium text-uppercase text-muted d-flex justify-content-between align-items-center">

          <span>
            <i class="mdi mdi-clock-outline"></i> {{ item.created_at }}
          </span>

          <!-- Status / Buttons -->
          <span v-if="item.to_user_id === userId && item.status === null">
            <button @click="$emit('reject', item.id)" class="btn-reject">Reject</button>
            <button @click="$emit('accept', item.id)" class="btn-accept">Accept</button>
          </span>

          <span v-else>
            <span
              v-if="item.status === 1"
              class="d-inline-flex align-items-center gap-2 text-success fw-semibold"
            >
              <i class="fa fa-check-circle"></i> Qabul qilindi
            </span>

            <span
              v-if="item.status === 0"
              class="d-inline-flex align-items-center gap-2 text-danger fw-semibold"
            >
              <i class="fa fa-times-circle"></i> Rad etildi
            </span>
          </span>

        </p>
      </div>

      <div class="px-2 fs-15">
        <input type="checkbox" class="form-check-input" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  props: ["item", "userId"],

  data() {
    return {
        card: []
    }
  },

  methods: {
    async loadTask(taskId) {
        try {
            const response = await api.get('/get-task/', {
                params: { task_id: taskId }
            });

            const task = response.data;

            let members = [];
            try {
                members = JSON.parse(task.members || "[]");
            } catch (e) {
              console.warn("JSON parse error:", e);
            }

            this.card = {
                id: task.id,
                text: task.task_name,
                description: task.task_description,
                file_path: task.file_path,
                members: members,
                deadline: task.task_deadline,
                created_at: task.created_at,
                updated_at: task.updated_at,
                user_id: task.user_id,
                status: task.status,
                user_fullname: task.user_fullname,
                file_name: task.file_name,
                column_id: task.column_id,
                is_checked: task.is_checked,
                comments_count: task.comments_count,
                unread_count: task.unread_count,
            };

            this.$emit('open-task', this.card);
        } catch (error) {
            console.error("Taskni yuklashda xato:", error);
        }
    }

  },

  computed: {
    imgUrl() {
      return `https://b-edo.uzautomotors.com/get-img/${this.item.from_user_tabel}`;
    }
  }
};
</script>

<style scoped>
.btn-accept {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 22px;
  border-radius: 15px;
  color: #2196f3;
  border: 1px solid #e3f2fd;
  background-color: #e3f2fd;
  box-shadow: none;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.4s ease-in-out;
}

.btn-reject {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 22px;
  border-radius: 15px;
  color: #f44336;
  border: 1px solid #ffebee;
  background-color: #ffebee;
  box-shadow: none;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.4s ease-in-out;
  margin-right: 5px;
}

.btn-accept:hover,
.btn-accept:active,
.btn-accept:focus {
  color: #2196f3!important;
  background-color: #e3f2fd!important;
  border: 1px solid #2196f3!important;
}

.btn-reject:hover,
.btn-reject:active,
.btn-reject:focus {
  color: #f44336;
  background-color: #ffebee;
  border: 1px solid #f44336;
}
</style>
